import Reveal from "./Reveal";
import { VALUES, PILLARS } from "../../data/pwt";

export default function About() {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="relative py-24 md:py-32 bg-[#F8F9F8]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-12 gap-10 md:gap-16">
          <Reveal className="col-span-12 md:col-span-4">
            <span className="overline">01 — Who we are</span>
            <h2 className="mt-6 font-serif text-4xl md:text-5xl tracking-tight text-[#0A140F] leading-[1.05]">
              An ecosystem of
              <br />
              boutique firms.
            </h2>
          </Reveal>

          <Reveal className="col-span-12 md:col-span-8" delay={120}>
            <div className="md:pl-12 md:border-l md:border-[#E5EBE6] space-y-6 font-sans text-lg leading-relaxed text-[#415248]">
              <p>
                PWT is the ecosystem of boutique firms that collaborate to deliver
                professional services across the full spectrum of business
                transformation.
              </p>
              <p>
                Each partner excels in their area of expertise, with ethics and
                professionalism, knowing that their success is tied to the success of
                the other partners in the ecosystem.
              </p>
            </div>
          </Reveal>
        </div>

        {/* Three pillars (from the profile) */}
        <Reveal className="mt-20 md:mt-24" delay={160}>
          <div className="grid grid-cols-1 md:grid-cols-3 border-y border-[#E5EBE6]">
            {PILLARS.map((p) => (
              <div
                key={p.label}
                data-testid={`about-pillar-${p.label.toLowerCase().replace(/[^a-z]+/g, "-")}`}
                className="p-8 md:p-10 border-b md:border-b-0 md:border-r border-[#E5EBE6] last:border-r-0"
              >
                <div className="overline">Principle</div>
                <div className="mt-4 font-serif text-2xl md:text-3xl text-[#0A140F]">
                  {p.label}
                </div>
                <p className="mt-3 font-sans text-base text-[#415248] leading-relaxed">
                  {p.description}
                </p>
              </div>
            ))}
          </div>
        </Reveal>

        {/* The two values */}
        <Reveal className="mt-16 md:mt-20" delay={220}>
          <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-12 items-start">
            <div className="md:col-span-4">
              <span className="overline">Our two values</span>
              <h3 className="mt-4 font-serif text-3xl md:text-4xl text-[#0A140F] leading-tight">
                Performance.
                <br />
                <span className="italic text-[#1A402B]">Trust.</span>
              </h3>
            </div>
            <div className="md:col-span-8 grid grid-cols-1 sm:grid-cols-2 gap-6">
              {VALUES.map((v) => (
                <div
                  key={v.label}
                  data-testid={`about-value-${v.label.toLowerCase()}`}
                  className="border border-[#E5EBE6] bg-white p-6 md:p-8"
                >
                  <div className="overline">Value</div>
                  <div className="mt-3 font-serif text-2xl md:text-3xl text-[#0A140F]">
                    {v.label}
                  </div>
                  <p className="mt-3 font-sans text-base text-[#415248] leading-relaxed">
                    {v.description}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
